import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useParams } from 'react-router';
import axios from 'axios';
import moment from 'moment';
import InfiniteScroll from "react-infinite-scroller";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ja from 'date-fns/locale/ja';
import UseAlertModal from '../Common/UseAlertModal';
import UseConfirmModal from '../Common/UseConfirmModal';
import { useToasts } from 'react-toast-notifications';
import { CSVLink } from "react-csv";
registerLocale('ja', ja);

const pageCount = 100;
const LIST = {
  MALL: '1',
  SHOP: '2',
  COUPON: '3',
  POINT: '4',
  INCUBE: '5'
};
const LIST_NAME = {
  '1': "負担額集計（施設負担）",
  '2': "負担額集計（店舗負担）",
  '3': "クーポン利用実績",
  '4': "付与ポイント集計",
  '5': "インキューブ天神店用負担割合",
};
const MonthlyDownload = (props) => {
  const { siteId } = useParams();
  const { setting, user } = props;
  const [condition, setCondition] = useState({ target_date: null });
  const [lockData, setLockData] = useState(false);
  const [historySearch, setHistorySearch] = useState(false);
  const [usePointMall, setUsePointMall] = useState(null);
  const [usePointShop, setUsePointShop] = useState(null);
  const [useCoupon, setUseCoupon] = useState(null);
  const [addPoint, setAddPoint] = useState(null);
  const [incube, setIncube] = useState(null);
  const [page, setPage] = useState(0);
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);
  const [alertModalMessage, setAlertModalMessage] = useState('');
  const [selectedList, setSelectedList] = useState(LIST.MALL);
  const [csvData, setCsvData] = useState(null);
  const csvRef = useRef();
  const { addToast } = useToasts();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [confirmModalMessage, setConfirmModalMessage] = useState('');
  const [onConfirm, setOnConfirm] = useState(() => () => { });

  const refreshMaster = useCallback(async () => {
    var con = { target_date: moment().add(-1, 'month').startOf('day').toDate() };
    if (setting) {
      setLockData(true);
      setCondition(con)
      setLockData(false);
    }
  }, [setting]);

  const closeAlertModal = () => {
    setIsAlertModalOpen(false);
  };

  const refreshHistory = useCallback(async () => {
    if (historySearch) {
      try {
        setLockData(true);
        const jwt = localStorage.getItem('jwt');
        var reg_params = {
          ...condition,
          site_id: siteId,
          target_date: condition.target_date ? moment(condition.target_date, 'YYYYMMDD').format('YYYY-MM-DD') : null,
        }
        // ポイントデータ取得
        const data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/points/backyard/monthlydownload`, reg_params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        })).data;
        if (data.result) {
          setUsePointMall(data.use_point_mall);
          setUsePointShop(data.use_point_shop);
          setUseCoupon(data.coupon);
          setAddPoint(data.add_point);
          setIncube(data.incube);
        } else {
          setAlertModalMessage("検索に失敗しました")
          setIsAlertModalOpen(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLockData(false);
        setHistorySearch(false);
      }
    }
  }, [condition, siteId, historySearch]);

  const setConditionValue = (value, name) => {
    setCondition({ ...condition, [name]: value });
  }

  const getResponseData = (selected) => {
    var res;
    if (selected === LIST.MALL) {
      res = usePointMall;
    }
    if (selected === LIST.SHOP) {
      res = usePointShop;
    }
    if (selected === LIST.COUPON) {
      res = useCoupon;
    }
    if (selected === LIST.POINT) {
      res = addPoint;
    }
    if (selected === LIST.INCUBE) {
      res = incube;
    }
    if (!res) {
      return null;
    }
    return res;
  }

  const getCsv = (selected) => {
    setLockData(true);
    setCsvData(null);
    var res = getResponseData(selected);
    if (!res) {
      setLockData(false);
      return;
    }
    const list = res.data;
    const head = res.fields.map(f => ({ label: f, key: f }));

    setCsvData({ header: head, list: list });
    setLockData(false);
  }

  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };

  const execExportSAP = async () => {
    setConfirmModalMessage('SAP連携を実行します。よろしいですか？');
    setIsConfirmModalOpen(true);
    setOnConfirm(() => async () => {
      try {
        setLockData(true);
        const jwt = localStorage.getItem('jwt');
        var reg_params = {
          site_id: siteId,
          mall_id: user.mallId,
        }
        // ポイントデータ取得
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/exporter/mall/sap/admin`, reg_params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
        addToast(`SAP連携が完了しました。`, { appearance: 'success' });
      } catch (error) {
        console.log(error);
        setAlertModalMessage("SAP連携に失敗しました");
        setIsAlertModalOpen(true);
      } finally {
        setIsConfirmModalOpen(false);
        setLockData(false);
      }
    });
  }

  useEffect(() => {
    refreshHistory()
  }, [refreshHistory]);

  useEffect(() => {
    refreshMaster();
  }, [refreshMaster]);

  useEffect(() => {
    if (csvData) {
      csvRef.current.link.click();
      setCsvData(null);
    }
  }, [csvData])

  const renderTable = (selected) => {
    var res = getResponseData(selected);
    if (!res) {
      return;
    }
    return <div className="print-list">
      <div className="row mb-0  ">
        <div className="col"><h4>{LIST_NAME[selected]}</h4></div>
        <div className="col-3 mx-0 align-self-center text-right border h-100">
          <div className="row px-0">
            <div className="col-auto py-1 px-2 bg-lightwhite h-100">一覧表件数</div>
            <div className="col py-1">{res.count.toLocaleString()}</div>
          </div>
        </div>
      </div>
      <div className="row mb-3 p-0">
        <div className="col-12 p-0">
          <InfiniteScroll
            loadMore={(p) => setPage(Number(p) * pageCount)}    //項目を読み込む際に処理するコールバック関数 
            hasMore={(res.data.length > page)}         //読み込みを行うかどうかの判定
            loader={<div key={-1}>{res.data.length}件中 {page + pageCount}件まで表示中（スクロールで読み込み）</div>}       //読み込み最中に表示する項目
          >
            <table className="table table-bordered table-striped" height="1">
              <thead className={`table-info`}>
                <tr>
                  {res.fields.map((f, fidx) =>
                    <th className="text-center align-middle text-nowrap" key={fidx}>
                      {f}
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {res.data && res.data.length === 0 && <tr><td colSpan={res.fields.length} className='text-center'>対象データなし</td></tr>}
                {res.data.map((data, idx) => (idx < (page + pageCount) &&
                  <tr key={idx}>
                    {res.fields.map((f, fidx) =>
                      <td className="text-center align-middle p-1" key={`${idx}-${fidx}`}>
                        {data[f]}
                      </td>
                    )}
                  </tr>
                ))
                }
              </tbody>
            </table>
          </InfiniteScroll>
        </div>
      </div>
    </div>
  }

  return (
    <div className="container">
      <UseAlertModal isOpen={isAlertModalOpen} message={alertModalMessage} onClose={closeAlertModal} />
      <UseConfirmModal isOpen={isConfirmModalOpen} message={confirmModalMessage} onConfirm={onConfirm} onClose={closeConfirmModal} disabled={lockData}/>
      <div className="row mx-0 my-2 px-1-env border p-2">
        <div className="col-2 text-center align-bottom align-self-end">
          <button type="button"
            className={`btn btn-primary mx-1 w-100`}
            disabled={lockData || !condition.target_date}
            onClick={() => execExportSAP()}>
            仕訳連携実行</button>
        </div>
        <div className="col-10 pt-1 pr-0 pl-1 text-left align-self-center text-danger">
          <span>※先月分の仕訳をSAPに連携します。MallProの仕訳連携が完了した後に実行してください。同じ月に2回実行しないようにご注意ください。</span>
        </div>
      </div>
      <div className="row mx-0 my-2 px-1-env">
        <div className="col-10 align-bottom align-self-end">
          <div className="row my-1">
            <div className="col-2 pt-1 pr-0 pl-1 text-center align-self-center">
              <span>集計年月</span>
            </div>
            <div className="col-4 pt-1 text-center">
              <div className='row'>
                <div className="col text-center">
                  <DatePicker className="custom-select text-left"
                    locale="ja" dateFormat="yyyy/MM" monthsShown="1" id={'searchdate_start'} name={'searchdate_start'}
                    popperPlacement='bottom'
                    selected={condition.target_date}
                    onChange={(value) => setConditionValue(value, "target_date")}
                    placeholderText="- 選択 -"
                    autoComplete='off'
                    showMonthYearPicker
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-2 text-center align-bottom align-self-end">
          <button type="button"
            className={`btn btn-primary mx-1 w-100`}
            disabled={lockData || !condition.target_date}
            onClick={() => setHistorySearch(true)}>
            検索</button>
        </div>
      </div>
      {(usePointMall !== null) && (
        <div className="row mx-0 my-4 px-1-env">
          <div className="col-10 align-bottom align-self-end">
            <div className="row my-1">
              <div className="col-2 pt-1 pr-0 pl-1 text-center align-self-center">
                <span>一覧表出力データ</span>
              </div>
              <div className="col-4 pt-1 text-center">
                <div className='row'>
                  <div className="col text-center">
                    <select className="custom-select w-100 text-center" value={selectedList} onChange={(e) => setSelectedList(e.target.value)}>
                      <option value={LIST.MALL}>{LIST_NAME[LIST.MALL]}</option>
                      <option value={LIST.SHOP}>{LIST_NAME[LIST.SHOP]}</option>
                      <option value={LIST.COUPON}>{LIST_NAME[LIST.COUPON]}</option>
                      <option value={LIST.POINT}>{LIST_NAME[LIST.POINT]}</option>
                      {user.mallId === 3 &&
                        <option value={LIST.INCUBE}>{LIST_NAME[LIST.INCUBE]}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div className="col-2 text-center align-bottom align-self-end">
            <button type="button"
              className={`btn btn-primary mx-1 w-100`}
              disabled={lockData || !condition.target_date}
              onClick={() => getCsv(selectedList)}>
              CSV出力</button>
            {csvData && <CSVLink data={csvData.list} headers={csvData.header} filename={`${LIST_NAME[selectedList]}_${moment(condition.target_date, 'YYYYMMDD').format('YYYYMM')}.csv`} className="d-none" ref={csvRef} />}
          </div>
        </div>
      )}
      {(usePointMall !== null) && (
        renderTable(selectedList)
      )}
    </div>
  )
}

export default MonthlyDownload;